var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoStreams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149,
    height: 111,
    viewBox: "0 0 149 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "no-streams-a",
    cx: 56,
    cy: 55.5,
    rx: 56,
    ry: 55.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: 55.5,
    fill: "#F4F7FB",
    fillRule: "nonzero",
    rx: 56,
    ry: 55.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "no-streams-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#no-streams-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C9DBFF",
    fillRule: "nonzero",
    d: "M60,9 L116,9 C119.866,9 123,12.134 123,16 C123,19.866 119.866,23 116,23 L60,23 C56.134,23 53,19.866 53,16 C53,12.134 56.134,9 60,9 Z M-26,88 L36,88 C38.21,88 40,89.79 40,92 C40,94.21 38.21,96 36,96 L-26,96 C-28.21,96 -30,94.21 -30,92 C-30,89.79 -28.21,88 -26,88 Z",
    mask: "url(#no-streams-b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2671FF",
    strokeDasharray: 6,
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M37,41 C66.18,30.063 99.04,25.207 119.447,45.1 M52,52 C78.721,47.006 89.69,45.334 116,51.5 M44,63 C52.339,65.444 97.53,69.907 116,59.5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5BBC3",
    fillRule: "nonzero",
    d: "M54.825,45.987 C52.898,36.284 44.313,29 34,29 C25.812,29 18.7,33.612 15.158,40.362 C6.63,41.262 0,48.434 0,57.126 C0,66.435 4.688,72.397 17,74 C29.312,75.603 43,75 52,74 C61,73 68,67.7 68,59.937 C68,52.513 62.192,46.494 54.825,45.987 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9DBFF",
    fillRule: "nonzero",
    d: "M87.5,80 L103.5,80 C105.433,80 107,81.567 107,83.5 C107,85.433 105.433,87 103.5,87 L87.5,87 C85.567,87 84,85.433 84,83.5 C84,81.567 85.567,80 87.5,80 Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5BBC3",
    fillRule: "nonzero",
    d: "M129.6,33 C135.015,33 139.472,34.814 142.977,38.445 C146.373,41.9 148.094,46.15 148.195,51.133 L148.2,51.603 L148.2,69.086 C148.2,69.59 147.739,69.95 147.273,69.843 L147.173,69.813 L140.167,67.168 C137.181,69.181 133.66,70.2 129.599,70.2 C124.185,70.2 119.727,68.387 116.223,64.823 C112.721,61.256 111,56.852 111,51.603 C111,46.416 112.721,42.008 116.223,38.445 C119.727,34.815 124.185,33 129.599,33 L129.6,33 Z M129.11,42.049 C126.463,42.049 124.245,42.968 122.46,44.81 C120.673,46.655 119.81,48.927 119.81,51.571 C119.81,54.211 120.673,56.484 122.46,58.388 C124.245,60.232 126.463,61.151 129.11,61.151 C131.759,61.151 133.915,60.231 135.702,58.388 C137.488,56.484 138.411,54.21 138.411,51.571 C138.411,48.927 137.488,46.655 135.701,44.811 C133.915,42.968 131.759,42.049 129.111,42.049 L129.11,42.049 Z M129.11,45.065 C132.625,45.065 135.474,47.991 135.474,51.6 C135.474,55.21 132.625,58.135 129.111,58.135 C125.596,58.135 122.747,55.209 122.747,51.6 C122.747,47.99 125.597,45.065 129.111,45.065 L129.11,45.065 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStreams);
export default __webpack_public_path__ + "static/media/no-streams.a4a70a42.svg";
export { ForwardRef as ReactComponent };